<template>
    <v-dialog
        v-model="showDialog"
        width="600px"
    >
        <div :style="`z-index: 9999; position: absolute; right: 7%; top: ${screen_width >= 1265 ? '13px' : '80px;'}; width: 500px`">
            <v-alert
                v-model="notif.show"
                transition="scroll-x-reverse-transition"
                :type="notif.type"
                :color="notif.color"
            >
                {{ notif.msg }}
            </v-alert>
        </div>
        <v-card>
            <v-form
                v-if="data"
                ref="form"
                @submit.prevent="submitForm"
            >
                <v-card-title style="background-color: #009688; color: white;">
                    Approve ACU Portal Access Status
                </v-card-title>
                <v-card-text style="height: 70vh; overflow-x: hidden; overflow-y: scroll;">
                    <v-text-field
                        v-model="data.ACCT_M"
                        readonly
                        label="Account Name"
                    />
                    <v-text-field
                        v-model="data.ACCT_N"
                        readonly
                        label="Account Number"
                    />
                    <v-select
                        v-model="data.STATUS"
                        readonly
                        :items="['ACTIVE', 'INACTIVE']"
                        return-object
                        label="Status"
                    />
                    <v-select
                        v-model="data.USE_STORED_RATES"
                        readonly
                        :items="['YES', 'NO']"
                        return-object
                        label="Use Stored Rates"
                    />
                    <v-text-field
                        v-model="data.VALIDITY_DAYS"
                        readonly
                        type="number"
                        label="Days of Approval Validity"
                    />
                    <v-text-field
                        v-model="data.STATUS_DATE"
                        readonly
                        type="date"
                        label="Portal Active Date"
                    />
                    <v-text-field
                        v-model="data.ACTIVE_UNTIL"
                        readonly
                        type="date"
                        label="Portal Active Until"
                    />
                    <v-combobox
                        ref="monthsOfContinuousMembership"
                        v-model="data.MEMB_MONTHS"
                        readonly
                        :items="[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]"
                        label="No. of Months of Continuous Membership"
                    />
                    <v-combobox
                        ref="monthsOfPayment"
                        v-model="data.PAID_MONTHS"
                        readonly
                        :items="[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]"
                        label="No. of Months of Payment"
                    />
                    <v-combobox
                        ref="monthsActiveOnTheCurrentContractPeriod"
                        v-model="data.PAID_MEMB_MONTHS"
                        readonly
                        :items="[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]"
                        label="No. of Months Active on the Current Contract Period"
                    />
                    <v-text-field
                        v-model="data.PROVISION_EXPIRY"
                        readonly
                        type="date"
                        label="Provision Expiry Date"
                    />
                    <v-textarea
                        v-model="data.INT_REMARKS"
                        readonly
                        label="Internal Remarks"
                        outlined
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="error"
                        width="100"
                        @click="showDialog = false"
                    >
                        close
                    </v-btn>
                    <v-btn
                        :loading="loading"
                        color="success"
                        type="submit"
                        width="100"
                    >
                        approve
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import { moment } from '../../../../utils/date-shim'
import { mapActions, mapGetters } from 'vuex'

export default {
    props: ['show', 'selectedAcu'],
    data: ()=>({
        screen_width: document.documentElement.clientWidth + 9,
        notif: {
            show: false,
            type: 'success',
            msg: 'Done',
            color: 'success'
        },
        loading: false,
        data: {
            'ACCT_N': null,
            'ACCT_M': null,
            'STATUS': null, // "A" for "ACTIVE", "I" for "INACTIVE"
            'STATUS_DATE': null, // Date in UTC+8:00 or date string in format YYYY-MM-DD
            'ACTIVE_UNTIL': null, // Date in UTC+8:00 or date string in format YYYY-MM-DD
            'MEMB_MONTHS': null,
            'PAID_MONTHS': null,
            'PAID_MEMB_MONTHS': null,
            'PROVISION_EXPIRY': null // Date UTC+0800 or Date String in format YYYY-MM-DD
        }
    }),
    computed: {
        ...mapGetters(['approveAcuStatusData']),
        showDialog: {
            get() {
                return this.show
            },
            set() {
                this.resetData()
                this.$emit('closeDialog')
            }
        }
    },
    watch: {
        notif: {
            handler(newVal) {
                if (newVal.show) {
                    if (newVal.timeout !== 0) {
                        setTimeout(() => {
                            this.notif.show = false
                        }, newVal.timeout)
                    }
                }
            },
            deep: true
        },
        approveAcuStatusData(newVal) {
            if (newVal && newVal.status === 200) {
                // this.acuActiveList()
                this.$emit('refreshAcuList', this.data.ACCT_N )
                this.$emit('closeDialog')
            } else {
                this.notif.type = 'error'
                this.notif.color = 'error'
                this.notif.timeout = 5000
                this.notif.msg = newVal.state
                this.notif.show = true
            }
            this.loading = false
        },
        selectedAcu: {
            handler(newVal) {
                if (newVal) {
                    this.data = structuredClone(newVal)
                    this.data.ACTIVE_UNTIL = this.data.ACTIVE_UNTIL ? this.formatDate(this.data.ACTIVE_UNTIL) : this.selectedAcu.AEXP_D
                    this.data.STATUS_DATE = this.data.STATUS_DATE ? this.formatDate(this.data.STATUS_DATE) : this.formatDate(new Date())
                    this.data.PROVISION_EXPIRY = this.data.PROVISION_EXPIRY ? this.formatDate(this.data.PROVISION_EXPIRY) : this.selectedAcu.AEXP_D
                    this.data.STATUS = this.data.STATUS === 'ACTIVE' || this.data.STATUS === 'PENDING' ? 'ACTIVE' : 'INACTIVE'
                    this.data.USE_STORED_RATES = this.data.USE_STORED_RATES === 1 ? 'YES' : 'NO'
                }
            },
            immediate: true,
            deep: true
        }
    },
    mounted() {
        window.addEventListener('resize', this.onResize)
    },
    destroyed(){
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        ...mapActions(['acuActiveList', 'approveAcuStatus']),
        resetData() {
            this.data = structuredClone(this.selectedAcu)
            this.data.ACTIVE_UNTIL = this.data.ACTIVE_UNTIL ? this.formatDate(this.data.ACTIVE_UNTIL) : this.selectedAcu.AEXP_D
            this.data.STATUS_DATE = this.data.STATUS_DATE ? this.formatDate(this.data.STATUS_DATE) : this.formatDate(new Date())
            this.data.PROVISION_EXPIRY = this.data.PROVISION_EXPIRY ? this.formatDate(this.data.PROVISION_EXPIRY) : this.selectedAcu.AEXP_D
            this.data.STATUS = this.data.STATUS === 'ACTIVE' || this.data.STATUS === 'PENDING' ? 'ACTIVE' : 'INACTIVE'
            this.data.USE_STORED_RATES = this.data.USE_STORED_RATES === 1 ? 'YES' : 'NO'
        },
        formatDate(date) {
            return moment(date).utcOffset('+0800').format('YYYY-MM-DD')
        },
        submitForm() {
            this.$nextTick(()=>{
                this.$refs.monthsOfContinuousMembership.blur()
                this.$refs.monthsOfPayment.blur()
                this.$refs.monthsActiveOnTheCurrentContractPeriod.blur()
                this.$nextTick(()=>{
                    if (this.$refs.form.validate()) {
                        this.approveAcuStatus({ ACCT_N: this.data.ACCT_N })
                    }
                })
            })
        },
        onResize() {
            this.screen_width = document.documentElement.clientWidth
            this.screen_width = this.screen_width + 9
        }
    }
}
</script>
